module.exports = __webpack_public_path__ + "static/404-error-img-dd9c094cf25b772128d443ba882cee3a.png";